import React, { ReactNode } from 'react';

interface ActionButtonProps {
  onClick: () => void;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  mobileFixed?: boolean;
  disabled: boolean
}

const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  icon,
  children,
  className = '',
  variant = 'primary',
  fullWidth = false,
  size = 'md',
  mobileFixed = false,
}) => {
  // Base styling
  const baseClasses =
    'flex items-center justify-center gap-2 transition duration-300 shadow-sm rounded-full';

  // Size classes
  const sizeClasses = {
    sm: 'py-1.5 px-3 text-sm',
    md: 'py-2 px-4 text-base',
    lg: 'py-3 px-6 text-lg',
  };

  // Variant classes
  const variantClasses = {
    primary: 'bg-red-600 hover:bg-red-700 text-white',
    secondary: 'bg-blue-600 hover:bg-blue-700 text-white',
    danger: 'bg-yellow-600 hover:bg-yellow-700 text-white',
  };

  // Width class
  const widthClass = fullWidth ? 'w-full' : '';

  // Desktop button
  const desktopButton = (
    <button
      onClick={onClick}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${widthClass} ${className}`}
    >
      {icon && icon}
      {children}
    </button>
  );

  // If mobileFixed is true, render a different version for mobile
  if (mobileFixed) {
    return (
      <>
        <div className="hidden md:block">{desktopButton}</div>

        {/* Mobile fixed button */}
        <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 z-10">
          <button
            onClick={onClick}
            className={`flex items-center justify-center gap-2 ${variantClasses[variant]} py-3 w-full rounded-lg shadow-md`}
          >
            {icon && icon}
            {children}
          </button>
        </div>
      </>
    );
  }

  return desktopButton;
};

export default ActionButton;
